// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f713d6f","455":"36b4b2ec"}[chunkId] + ".chunk.js";
};